import { Divider, Grid, Typography } from '@mui/material';
import React, { useContext } from 'react'
import globalStyles from "../../../assets/styles/global.module.scss";
import style from "../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss";
import GlobalButton from '../../utility/globalButton/button';
import { WhatsappCampaignContext, WhatsappCampaignContextPayload } from '../../../context/whatsappCampaignContext';
import { useNavigate } from 'react-router-dom';
import campaignStyles from "../../../assets/styles/componentStyles/whatsappCampaignStyles/whatsappCampaignStyle.module.scss";
import { WorkflowContext, WorkflowContextPayload } from '../../../context/workflowContext';

const IntegrateBusinessAccountPopup = (props: any) => {

    const { title } = props;

    const navigate = useNavigate(); 
    const { setFlagIntegrateBusinessAccountPopup } = useContext(WhatsappCampaignContext) as WhatsappCampaignContextPayload;
    const { setFlagIntegrateBusinessAccountPopup: setFlagWorkflowIntegrateBusinessAccount } = useContext(WorkflowContext) as WorkflowContextPayload

    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <Grid container className={`${globalStyles.flexColumn} ${globalStyles.justifyCenter} ${style.popupBodyGridContainer}`} gap={4} mt={2}>
                        <Grid item xs={12} className={globalStyles.fullwidth}>
                            <Typography className={campaignStyles.connectBusinessAccountTypo}>
                                {title}
                            </Typography>
                        </Grid>  
                        <Grid item xs={12}>
                            <Grid container gap={2} justifyContent={"center"} alignItems={"center"}>
                                <Grid item>
                                    <GlobalButton
                                        buttonText="Skip for now"
                                        className='borderedButtonStyle'
                                        sx={{ width: "150px" }}
                                        onClick={() => {
                                            setFlagIntegrateBusinessAccountPopup(false);
                                            setFlagWorkflowIntegrateBusinessAccount(false);
                                        }}
                                    />
                                </Grid>
                                <Grid item>
                                    <GlobalButton
                                        buttonText="Integrate Now"
                                        className='primaryButtonStyle'
                                        sx={{ width: "150px" }}
                                        onClick={() => {
                                            window.open(`/channels/viewintegration/whatsapp`, "_blank");
                                            setFlagIntegrateBusinessAccountPopup(false); 
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default IntegrateBusinessAccountPopup
